import React from "react";
import "./blogvoting.css";

const BlogVoting = ({
  handleThumbsUp,
  handleThumbsDown,
  likes,
  dislikes,
  userId,
}) => {
  const hasLiked = likes?.includes(userId);
  const hasDisliked = dislikes?.includes(userId);

  return (
    <div className="blog-voting-simple">
      <div className="voting-buttons">
        <button
          className={`vote-btn ${hasLiked ? "active-like" : ""}`}
          onClick={userId ? handleThumbsUp : null}
          disabled={!userId}
          title={
            !userId
              ? "Please login to vote"
              : hasLiked
              ? "Remove your like"
              : "Like this blog"
          }
        >
          <span className="vote-icon">👍</span>
          <span className="vote-count">{likes?.length || 0}</span>
        </button>

        <button
          className={`vote-btn ${hasDisliked ? "active-dislike" : ""}`}
          onClick={userId ? handleThumbsDown : null}
          disabled={!userId}
          title={
            !userId
              ? "Please login to vote"
              : hasDisliked
              ? "Remove your dislike"
              : "Dislike this blog"
          }
        >
          <span className="vote-icon">👎</span>
          <span className="vote-count">{dislikes?.length || 0}</span>
        </button>
      </div>
    </div>
  );
};

export default BlogVoting;
